import { stumble } from '@ipfabric/frontend-shared-assets/utils/stumble/stumble';

const SNOOZED_NOTIFICATIONS_LOCAL_STORAGE = 'snoozedNotifications';

export const snoozeNotification = (snoozeKey: string): void => {
  const version = localStorage.getItem('version');
  if (!version) {
    stumble('Version not saved in local storage');
    return;
  }

  const snoozedNotifications = getSnoozedNotifications();

  if (snoozedNotifications.includes(snoozeKey)) {
    return;
  }

  snoozedNotifications.push(snoozeKey);
  localStorage.setItem(
    SNOOZED_NOTIFICATIONS_LOCAL_STORAGE,
    JSON.stringify({ [version]: snoozedNotifications }),
  );
};

export const getSnoozedNotifications = (): string[] => {
  const version = localStorage.getItem('version');
  if (!version) {
    return [];
  }

  const localStorageSnoozed = localStorage.getItem(
    SNOOZED_NOTIFICATIONS_LOCAL_STORAGE,
  );
  const parsedSnoozed = localStorageSnoozed
    ? JSON.parse(localStorageSnoozed)
    : {};

  return parsedSnoozed[version] ?? [];
};
